import { render } from "./CaraBayaran.vue?vue&type=template&id=053a8bd0"
import script from "./CaraBayaran.vue?vue&type=script&lang=js"
export * from "./CaraBayaran.vue?vue&type=script&lang=js"

import "./CaraBayaran.vue?vue&type=style&index=0&id=053a8bd0&lang=css"
import "./CaraBayaran.vue?vue&type=style&index=1&id=053a8bd0&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__